import { render } from "./IconPicker.vue?vue&type=template&id=ccc89c20&ts=true"
import script from "./IconPicker.vue?vue&type=script&lang=ts"
export * from "./IconPicker.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/singlepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__